import React from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { RootState } from "../../redux/reducer";
import { connect, ConnectedProps } from "react-redux";
import "react-tabs/style/react-tabs.css";
import PagodaSummaryTab from "../PagodaNew/PagodaTabs/PagodaSummaryTab"
import PagodaProductTab from "../PagodaNew/PagodaTabs/PagodaProductTab";
import PagodaByStoreTab from "../PagodaNew/PagodaTabs/PagodaByStore";

// const useStyles = makeStyles({
//     root: {
//       width: "100%",
//     },
//     container: {
//       maxHeight: 440,
//     },
//   });


type PropsFromRedux = ConnectedProps<typeof connector>;
type KJMainProps = PropsFromRedux & {};
const PagodaMainScreen: React.FC<KJMainProps> = ({ ...rest }) => {

    return (
        <div
        style={{
          display: "flex",
          flex: 1,
          padding: 16,
          flexDirection: "column",
        }}
      >

      <Tabs>
        <TabList>
          <Tab>Summary</Tab>
          <Tab>By Store</Tab>
          <Tab>Product Data</Tab>
        </TabList>
        <TabPanel>
            <PagodaSummaryTab />
        </TabPanel>
        <TabPanel>
            <PagodaByStoreTab />
        </TabPanel>
        <TabPanel>
          <PagodaProductTab/>
        </TabPanel>
    </Tabs>
    </div>
    );
};

const mapState = (state: RootState) => ({});

const mapDispatch = {};

const connector = connect(mapState, {

});

export default connector(PagodaMainScreen);
